module.exports = __webpack_public_path__ + "b2637d75123fe6c9d8a4a9d5f5c114d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spacemarines-vignette-preview-460.jpg
// module id = 548
// module chunks = 0